import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

export default class VisitorsTasksController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { Tasks } = await import('reactRichComponents/visitors/Tasks');

    this.root = await this.reactRenderer.render(Tasks, 'react__visitors__tasks');
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
